import React, { useContext, useEffect } from "react";
import { RetrasosContext } from "../../context/RetrasosContext";
import GraficaFinanzas from "../finanzas/GraficaFinanzas";
import ChartCard from "../analiticas/ChartCard";
import Entradas from "../bitacora/Entradas";
import { Link } from "react-router-dom";

const ProgresoObra = ({ idProyecto, start_date, end_date }) => {
  const { retrasos, getRetrasos } = useContext(RetrasosContext);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto]);

  function fetchData() {
    getRetrasos(idProyecto, { start_date, end_date });
  }

  function renderComentarios() {
    if (Array.isArray(retrasos)) {
      if (retrasos.length === 0) {
        return <p>No hay retrasos registrados en la bitácora.</p>;
      }
      return <Entradas entradas={retrasos} />;
    }
  }

  return (
    <ChartCard>
      <div className="row">
        <h4 className="mb-3">Progreso de Obra</h4>
        <div className="col-md-12 col-xl-8 px-0">
          <GraficaFinanzas idProyecto={idProyecto} showCurrentMarker />
        </div>
        <div className="col-md-12 col-xl-4 border-left-1 bg-white progreso-obra-right">
          <h5 className="bold">Comentarios</h5>
          <div className="card bg-light p-3 progreso-obra-comentarios">
            {renderComentarios()}
          </div>
          <Link
            className="btn btn-outline-primary my-3"
            to={`/obra/${idProyecto}/bitacora`}
          >
            Ir a Bitacora
          </Link>
        </div>
      </div>
    </ChartCard>
  );
};

export default ProgresoObra;
